import * as yup from 'yup';

export const validationSchema = yup.object({
  firmId: yup.string().required('You must select a firm.'),
  url: yup.string().url('You must provide a valid URL').required('You must provide a URL.'),
  startDate: yup.string().required('You must provide a start date.'),
  endDate: yup.string().required('You must provide an end date.'),
  title1: yup.string().required('You must provide a title.'),
});

export const adSlotStatus = ['All', 'Active', 'Inactive'].map(item => ({
  key: item,
  value: item,
  text: item,
}));

export const firmValidationSchema = yup.object({
  name: yup.string().required('A name is required.'),
  logoUrl1: yup.string().url().notRequired().nullable(),
  website: yup.string().url().notRequired().nullable(),
  group: yup.string().notRequired().nullable(),
  buttonColor: yup.string().notRequired().nullable(),
  buttonText: yup.string().notRequired().nullable(),
  buttonTextColor: yup.string().notRequired().nullable(),
  moreInfoText: yup.string().notRequired().nullable(),
  backgroundColor: yup.string().notRequired().nullable(),
  backgroundTextColor: yup.string().notRequired().nullable(),
  popupBackgroundColor: yup.string().notRequired().nullable(),
  seeInsideMessage: yup.string().notRequired().nullable(),
  siteIds: yup.array().required('A site is required.'),
});

export const repValidationSchema = yup.object({
  name: yup.string().required('A name is required.'),
  showcaseFirmId: yup.string().required('A firm is required.'),
  email: yup.string().email('Invalid email address.').notRequired(),
  phone: yup.string().notRequired(),
  imageUrl: yup.string().url('Invalid URL').notRequired(),
});

export const repInitialValues = {
  name: '',
  email: '',
  phone: '',
  imageUrl: '',
  showcaseFirmId: '',
  representativeId: '',
};

export const listingValidationSchema = yup.object({
  description1: yup.string().required('A description is required.'),
  description2: yup.string().nullable(),
  line1: yup.string().nullable(),
  line2: yup.string().nullable(),
  line3: yup.string().nullable(),
  url: yup.string().url('You must provide a valid URL').required('You must provide a URL.').nullable(true),
  imageUrl: yup.string().required('You must provide an image'),
  showcaseFirmId: yup.string().required('You must select a firm'),
  type: yup.string().required('You must select a listing type'),
  price: yup
    .string()
    .test('price-if-property', 'A price is required', function (value) {
      const isProduct = this.parent.type === 'Product';
      if (isProduct) return true;
      return value;
    })
    .nullable(),
  address: yup
    .string()
    .test('address-required', 'An address is required', function (value) {
      const isProduct = this.parent.type === 'Product';
      if (isProduct) return true;
      return value;
    })
    .nullable(),
  city: yup
    .string()
    .test('city-required', 'A city is required', function (value) {
      const isProduct = this.parent.type === 'Product';
      if (isProduct) return true;
      return value;
    })
    .nullable(),
  state: yup
    .string()
    .test('state-required', 'A state is required', function (value) {
      const isProduct = this.parent.type === 'Product';
      if (isProduct) return true;
      return value;
    })
    .nullable(),
  zip: yup
    .string()
    .test('zip-required', 'A zip is required', function (value) {
      const isProduct = this.parent.type === 'Product';
      if (isProduct) return true;
      return value;
    })
    .nullable(),
});

export const listingInitialValues = {
  description1: '',
  description2: '',
  address: '',
  city: '',
  state: '',
  zip: '',
  line1: '',
  line2: '',
  line3: '',
  imageUrl: '',
  url: '',
  price: '',
  showcaseFirmId: '',
  backgroundTextColor: '',
  backgroundColor: '',
  buttonColor: '',
  buttonTextColor: '',
  buttonText: '',
  openHouseStartDate: '',
  openHouseEndDate: '',
};

export const slotValidationSchema = yup.object({
  startDate: yup.date().required('A start date required.'),
  endDate: yup.date().required('An end date is required.'),
  title1: yup.string().required('A title is required.'),
  title2: yup.string().notRequired(),
  url: yup.string().url('Invalid URL.').notRequired(),
  listingType: yup.string().required('Listing type is required.'),
  firms: yup.array().required('A firm is required.'),
  sites: yup.array().required('A site is required.'),
  items: yup.array().required('Items are required.'),
});

export const slotInitialValues = {
  startDate: new Date(),
  endDate: new Date(),
  title1: 'Property showcase',
  title2: '',
  url: '',
  listingType: '',
  firms: [],
  sites: [],
  items: [],
};

export const adSlotValidationSchema = yup.object({
  startDate: yup.date().required('A start date required.'),
  endDate: yup.date().required('An end date is required.'),
  title1: yup.string().required('A title is required.'),
  url: yup.string().url('Invalid URL.').notRequired(),
  // listingType: yup.string().required('Listing type is required.'),
  firmIds: yup.array().required('A firm is required.'),
  siteIds: yup.array().required('A site is required.'),
  itemIds: yup.array().required('Items are required.'),
});

export const adSlotInitialValues = {
  title1: '',
  title2: '',
  buttonText: '',
  buttonTextColor: '',
  buttonColor: '',
  backgroundColor: '',
  backgroundTextColor: '',
  url: '',
  listingType: '',
  startDate: new Date(),
  endDate: new Date(),
  analyticsCategory: '',
  firmIds: [],
  siteIds: [],
  itemIds: [],
  presentedByColor: '',
  presentedByFontWeight: '',
  logoHeight: 50,
  logoPadding: 5,
  tagColor: '#c2d503',
};
